export default __webpack_public_path__ + "static/media/star--white.9114ad14.svg";